export default "__VITE_ASSET__5CINY400__"